<template>
  <main>
    <!-- Diálogo para elegir el estilo de la capa raster -->
    <v-scale-transition>

      <v-card v-show="value" :color="$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'">
        <v-toolbar @click="collapsed = !collapsed" flat :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`" style="cursor: pointer;">
          <v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 16px;">{{$t('filtrar-rango-valores')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="collapsed = !collapsed">
            <v-icon>{{collapsed ? 'add' : 'remove'}}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
          <v-card-text v-show="!collapsed" class="px-3 py-0">

            <v-layout row wrap class="pb-1">
              <v-flex xs12>
                <v-range-slider
                  class="px-1"
                  hide-details
                  :thumb-label="true"
                  v-model="values"
                  :max="maxLimit"
                  :min="minLimit"
                  :step="step"
                ></v-range-slider>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <input type="color" style="width: 100%;" class="px-1" v-model="minColor"/>
              </v-flex>
              <v-flex xs6>
                <input type="color" style="width: 100%;" class="px-1" v-model="maxColor"/>
              </v-flex>
            </v-layout>

          </v-card-text>
        </v-slide-y-transition>
        <v-slide-y-transition>
          <v-card v-show="!collapsed" flat color="transparent">
            <v-card-text class="px-3">
              <v-layout row wrap>
                <v-flex xs6 class="text-xs-center">
                  <v-card class="mr-1">
                    <v-card-text class="px-0">
                      Mín: {{values[0].toFixed(2)}}
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs6 class="text-xs-center">
                  <v-card class="ml-1">
                    <v-card-text class="px-0">
                      Máx: {{values[1].toFixed(2)}}
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-slide-y-transition>
      </v-card>

    </v-scale-transition>
  </main>
</template>

<script>
import SourceTileWMS from 'ol/source/tilewms'

import config from '@/config'
import indicadoresParams from '../indicadores-default-params'

const geoserverURL = `${config.geoserver.geoserverURL}/wms`

/**
 * Componente para filtrar ráster por rangos de valores,
 * permitiendo elegir valorMin, valorMax así como los colores
 * colorMin, colorMax
 */
export default {
  props: ['rasterLayer', 'value'],
  data() {
    return {
      indicadoresParams,
      values: [0, 0],
      collapsed: false
    }
  },

  created() {
    this.setDefaultValues()
  },

  methods: {
    paintRaster() {
      if(!this.raster || !this.value) {
        return
      } 

      const { name: layers, url } = this.raster

      const env = this.envParams
      const STYLES = 'shared:dynamic-raster'
      const source = new SourceTileWMS({ url, params: { layers, STYLES, env }, crossOrigin: 'anonymous' })

      this.rasterLayer.setSource(source)
    },

    setDefaultValues() {
      //console.log('[SET DEFAULT VALUES]', this.defaultValues)
      if(this.defaultValues) {
        this.values = this.defaultValues
      }
    }
  },

  computed: {
    minValue() {
      return this.values[0]
    },

    maxValue() {
      return this.values[1]
    },
    raster() {
      return this.$store.getters.raster
    },

    indicador() {
      return this.$store.getters.indicador
    },

    envParams() {
      return `v1:${this.minValue};v2:${this.maxValue};c1:${this.minColor};c2:${this.maxColor}`
    },

    minLimit() {
      return this.indicador ? this.indicadoresParams[this.indicador]['range'][0] : 0
    },

    maxLimit() {
      return this.indicador ? this.indicadoresParams[this.indicador]['range'][1] : 0
    },

    step() {
      return this.indicador ? this.indicadoresParams[this.indicador]['step'] : 0
    },

    defaultValues() {
      return this.indicador ? this.indicadoresParams[this.indicador]['default'] : 0
    },

    minColor: {
      get() { return this.indicador && this.indicadoresParams[this.indicador]['colors'][0].replace('0x', '#') },
      set(value) {
        const maxValue = this.indicadoresParams[this.indicador]['colors'][1]
        this.indicadoresParams[this.indicador]['colors'] = [value.replace('#', '0x'), maxValue]
        this.paintRaster()
      }
    },

    maxColor: {
      get() { return this.indicador && this.indicadoresParams[this.indicador]['colors'][1].replace('0x', '#') },
      set(value) {
        const minValue = this.indicadoresParams[this.indicador]['colors'][0]
        this.indicadoresParams[this.indicador]['colors'] = [minValue, value.replace('#', '0x')]
        this.paintRaster()
      }
    },
  },

  watch: {
    minValue() { this.paintRaster() },
    maxValue() { this.paintRaster() },
    value() {
      //console.log('change value')
      this.setDefaultValues()
      this.paintRaster()
      this.collapsed = false
    },
    raster() { this.paintRaster() },
    indicador() { this.setDefaultValues() }
  }
}
</script>





// WEBPACK FOOTER //
// raster-range-filter.vue?06945f69